const FormatResponse = (AllData) => {
  const data = AllData.data;

  const ResponseLayout = {
    error: !data.data,
    message: data.message,
    errors: data.errors,
    data: data.data,
    meta: data.meta,
  };

  return ResponseLayout;
};

export default FormatResponse;
